export const getName = (aliases = {}, member = {}) =>
  aliases[member?._id] ?? member?.Name ?? member?.Email ?? "Deleted Account";
